import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./Card.css";

const CardWrapper = ({ children, className }) => (
  <div className={cx(styles.wrapper, className)}>{children}</div>
);

CardWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default CardWrapper;
